import { Injectable, signal } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavService {
  showClass = false;

  public currentUrl = signal<string | undefined>(undefined);

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        console.log('[NavService] NavigationEnd | urlAfterRedirects:', event.urlAfterRedirects);
        this.currentUrl.set(event.urlAfterRedirects);
      }
    });
  }
}
